import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/icons/Australia.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/about-us/why-incluso/whyincluso-main-pic.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/about-us/why-incluso/whyincluso-Pic1.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/about-us/why-incluso/whyincluso-Pic2.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/about-us/why-incluso/whyincluso-Pic3.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Card/Mobile-Review-Card.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Card/Review-card.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Compliances/Compliance-to-31000.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Compliances/Compliance-to-ISO-20000.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Compliances/ISO-14001---Environment.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Compliances/ISO-27001---Information-Security.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Compliances/ISO-45001-Safety.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Compliances/ISO-9001---Quality.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Concierge.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Create the world we want cards/Image-1.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Create the world we want cards/Image-2.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Create the world we want cards/Image-3.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Create the world we want cards/Image-4.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Create the world we want cards/Image-5.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Google-5-star.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/hearts/Build-trust-half-heart.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/hearts/Creating-the-world-we-want-heart.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/hearts/Half-heart-element.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/hearts/half-heart-with-tag-line.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/logo/Incluso Services Logogram-Icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/NDIS/NDIS-Registered-Provider-white-text.png");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/pageSpecific/contact/contactButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_components/section/testimonial/testimonialSlider.tsx");
